module.exports = __webpack_public_path__ + "img/Support-skill-1.550fe2a8.png";